module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch3"
    }
  }, [_vm._v("ANCESTORS MAJESTIC")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Majestic, O ancestors majestic")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("ablaze shaping blessings this")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("bounty on and on stretching")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("boundless across your lands:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("we bring you crystalline wine")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and you answer our prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We bring well-seasoned soup,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("approach mindful and tranquil")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and hushed in silent homage,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("leaving all strife far behind,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and you ease our pained brows,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("letting old age grow boundless.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Hubs veiled and harness inlaid,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("eight phoenix-bells clittering,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("we offer sacrifice and homage.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The Mandate we received is vast and mighty.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It’s from Heaven—this rich ease,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("this life abounding in harvests.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We offer homage, and you accept,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sending boundless good fortune,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("honoring autumn and winter")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("offerings from T’ang’s children.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f27efee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0